// Where the inventory's hover pill goes.
//
// Hovering a slot names the item; clicking it opens the menu. The pill exists so that looking through
// a pack answers "what is that?" without a context menu springing open under the pointer on its way
// across the grid.
//
// Pixi-free, like crafting_grid.ts beside it: the drawing is three lines of Graphics and the part
// worth guarding is the arithmetic, which has to keep a pill on an edge slot inside the panel.

// Clear air between the pill and the slot it names.
export const PILL_GAP = 5
// How close to the panel's edge a pill may sit.
export const PILL_EDGE_PAD = 4

export interface NamePillLayout {
    x: number
    y: number
}

export const namePillLayout = ({
    slotX,
    slotY,
    slotSize,
    pillW,
    pillH,
    panelW,
}: {
    slotX: number
    slotY: number
    slotSize: number
    pillW: number
    pillH: number
    panelW: number
}): NamePillLayout => {
    // Centred over the slot...
    const centred = slotX + slotSize / 2 - pillW / 2
    // ...then pulled back inside the panel. A pill on the first or last column would otherwise hang
    // off the side of it, and a long item name makes that the common case rather than the rare one.
    const maxX = Math.max(PILL_EDGE_PAD, panelW - pillW - PILL_EDGE_PAD)
    const x = Math.round(Math.max(PILL_EDGE_PAD, Math.min(maxX, centred)))

    // Above the slot, unless that is off the top of the panel -- the top row is where this bites.
    const y = Math.round(Math.max(PILL_EDGE_PAD, slotY - pillH - PILL_GAP))

    return { x, y }
}
